var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191.98,
    height: 54.77,
    viewBox: "0 0 191.98 54.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M0,0H191.98V54.77H0ZM0,0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(-2920.391 -18469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(2920.391 18469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M184.855,53.415H7.322A6.371,6.371,0,0,1,.809,47.195V7.026A6.371,6.371,0,0,1,7.322.8H184.855a6.371,6.371,0,0,1,6.513,6.221V47.195a6.371,6.371,0,0,1-6.513,6.221",
    transform: "translate(-0.095 -0.127)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M7.223,1.359a5.681,5.681,0,0,0-5.8,5.54V47.067a5.681,5.681,0,0,0,5.8,5.54H184.76a5.681,5.681,0,0,0,5.8-5.54V6.9a5.681,5.681,0,0,0-5.8-5.54ZM184.76,53.97H7.223A7.076,7.076,0,0,1,0,47.067V6.9A7.076,7.076,0,0,1,7.223,0H184.76a7.076,7.076,0,0,1,7.223,6.9V47.067a7.076,7.076,0,0,1-7.223,6.9",
    transform: "translate(0 0.001)",
    fill: "#a7a9ab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M74.766,15.8l-.731-2.186c-.179-.54-.331-1.142-.469-1.656h-.028c-.134.513-.276,1.129-.438,1.656L72.384,15.8Zm-2.657,1.221-.8,2.515H69.559l2.978-8.867H74.7l3.015,8.867H75.9l-.841-2.515",
    transform: "translate(-8.192 -1.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M81.427,13.594l1.089,3.245a16.667,16.667,0,0,1,.451,1.606h.041c.124-.527.276-1.027.455-1.606l1.075-3.245h1.775L83.753,20H82.089l-2.5-6.405",
    transform: "translate(-9.374 -2.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M92.467,16.838c-1.2-.013-2.343.224-2.343,1.2a.871.871,0,0,0,.965.922,1.384,1.384,0,0,0,1.334-.882.971.971,0,0,0,.045-.355Zm1.651,1.593a8.207,8.207,0,0,0,.11,1.537H92.7l-.121-.708h-.045a2.5,2.5,0,0,1-1.982.852,1.946,1.946,0,0,1-2.106-1.906c0-1.606,1.5-2.432,3.977-2.419v-.105c0-.421-.176-1.119-1.361-1.119a3.682,3.682,0,0,0-1.806.474l-.331-1.053a5.017,5.017,0,0,1,2.426-.563,2.449,2.449,0,0,1,2.767,2.709",
    transform: "translate(-10.417 -2.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M97.577,13.095h1.692V19.5H97.577Zm.837-.922a.961.961,0,1,1,.017,0",
    transform: "translate(-11.481 -1.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M102.27,19.448h1.7V10.094h-1.7Zm0,0",
    transform: "translate(-12.045 -1.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M110.459,16.838c-1.2-.013-2.343.224-2.343,1.2a.871.871,0,0,0,.965.922,1.389,1.389,0,0,0,1.337-.882,1.047,1.047,0,0,0,.041-.355Zm1.651,1.593a8.207,8.207,0,0,0,.11,1.537h-1.527l-.124-.708h-.041a2.51,2.51,0,0,1-1.985.852,1.948,1.948,0,0,1-2.106-1.906c0-1.606,1.5-2.432,3.98-2.419v-.105c0-.421-.179-1.119-1.365-1.119a3.658,3.658,0,0,0-1.8.474l-.331-1.053a5,5,0,0,1,2.423-.563,2.449,2.449,0,0,1,2.767,2.709",
    transform: "translate(-12.536 -2.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M117.27,16.8a1.71,1.71,0,0,0,.041.382,1.535,1.535,0,0,0,1.5,1.132c1.061,0,1.709-.8,1.709-2.1,0-1.132-.565-2.054-1.7-2.054a1.556,1.556,0,0,0-1.5,1.185,1.853,1.853,0,0,0-.055.421Zm-1.7-6.708h1.7v3.828h.028a2.456,2.456,0,0,1,2.147-1.024c1.64,0,2.809,1.3,2.795,3.249a3.123,3.123,0,0,1-3.043,3.446,2.332,2.332,0,0,1-2.119-1.106h-.028l-.083.961H115.52c.028-.434.055-1.145.055-1.791",
    transform: "translate(-13.606 -1.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M125.4,19.448h1.692V10.094H125.4Zm0,0",
    transform: "translate(-14.769 -1.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M134.182,16.091a1.4,1.4,0,0,0-1.389-1.567,1.616,1.616,0,0,0-1.558,1.567Zm-2.946,1.129c.041,1.159.993,1.659,2.068,1.659a5.631,5.631,0,0,0,1.858-.29l.248,1.1a6.207,6.207,0,0,1-2.34.408c-2.178,0-3.46-1.274-3.46-3.232a3.232,3.232,0,0,1,3.281-3.446,2.83,2.83,0,0,1,2.891,3.117,3.737,3.737,0,0,1-.055.681",
    transform: "translate(-15.265 -2.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M145.685,18.945c.961,0,1.637-.9,1.637-2.2,0-1-.469-2.159-1.623-2.159-1.2,0-1.682,1.119-1.682,2.186,0,1.234.648,2.169,1.651,2.169Zm-.055,1.172a3.169,3.169,0,0,1-3.36-3.3,3.235,3.235,0,0,1,3.47-3.394,3.143,3.143,0,0,1,3.332,3.288,3.248,3.248,0,0,1-3.429,3.407",
    transform: "translate(-16.756 -2.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M152.231,15.472c0-.737-.024-1.356-.052-1.909h1.472l.083.961h.041a2.488,2.488,0,0,1,2.15-1.1c1.168,0,2.381.721,2.381,2.748v3.8h-1.7V16.355c0-.922-.358-1.619-1.279-1.619a1.415,1.415,0,0,0-1.323.948,1.442,1.442,0,0,0-.083.513v3.772h-1.7",
    transform: "translate(-17.923 -2.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M167.623,11.641v1.642h1.609v1.211h-1.609v2.814c0,.79.221,1.185.865,1.185a2.307,2.307,0,0,0,.662-.066l.028,1.221a3.787,3.787,0,0,1-1.227.171,2,2,0,0,1-1.458-.523,2.449,2.449,0,0,1-.538-1.8v-3H165V13.283h.951V12.088",
    transform: "translate(-19.434 -1.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M171.934,10.094h1.7v3.815h.028a2.2,2.2,0,0,1,.841-.724,2.5,2.5,0,0,1,1.168-.286c1.144,0,2.34.721,2.34,2.775v3.775h-1.692v-3.6c0-.922-.358-1.633-1.3-1.633a1.409,1.409,0,0,0-1.32.908,1.394,1.394,0,0,0-.069.487v3.841h-1.7",
    transform: "translate(-20.25 -1.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M185.636,16.091a1.4,1.4,0,0,0-1.392-1.567,1.613,1.613,0,0,0-1.554,1.567Zm-2.947,1.129c.041,1.159.989,1.659,2.064,1.659a5.6,5.6,0,0,0,1.857-.29l.252,1.1a6.213,6.213,0,0,1-2.343.408c-2.175,0-3.457-1.274-3.457-3.232a3.231,3.231,0,0,1,3.277-3.446,2.83,2.83,0,0,1,2.891,3.117,3.738,3.738,0,0,1-.055.681",
    transform: "translate(-21.325 -2.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M45.268,29.513A7.865,7.865,0,0,1,49.2,22.891a8.6,8.6,0,0,0-6.668-3.443c-2.8-.28-5.521,1.606-6.948,1.606-1.458,0-3.66-1.577-6.027-1.531a8.945,8.945,0,0,0-7.471,4.351c-3.226,5.342-.82,13.189,2.274,17.507,1.551,2.113,3.357,4.476,5.724,4.391,2.316-.092,3.181-1.409,5.976-1.409,2.771,0,3.584,1.409,6,1.356,2.485-.039,4.049-2.123,5.541-4.259a17.015,17.015,0,0,0,2.536-4.931,7.694,7.694,0,0,1-4.873-7.017",
    transform: "translate(-2.421 -3.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M42.667,15.046a7.534,7.534,0,0,0,1.861-5.569,8.437,8.437,0,0,0-5.355,2.646,7.185,7.185,0,0,0-1.909,5.362,6.965,6.965,0,0,0,5.4-2.439",
    transform: "translate(-4.384 -1.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M78.853,39.373l-1.6-4.717q-.253-.721-.955-3.4h-.055c-.186.767-.489,1.9-.9,3.4l-1.571,4.717Zm5.528,7.534H81.151L79.383,41.6H73.242l-1.685,5.306H68.414l6.093-18.064h3.756",
    transform: "translate(-8.058 -4.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M99.421,41.232a5.186,5.186,0,0,0-.9-3.137,3.152,3.152,0,0,0-2.636-1.287,3.235,3.235,0,0,0-2.033.711,3.312,3.312,0,0,0-1.2,1.866,3.6,3.6,0,0,0-.138.879v2.172a3.391,3.391,0,0,0,.91,2.4,3.087,3.087,0,0,0,2.371.978,3.133,3.133,0,0,0,2.664-1.261,5.326,5.326,0,0,0,.958-3.321m3.088-.109a7.2,7.2,0,0,1-1.882,5.253,5.621,5.621,0,0,1-4.18,1.715,4.244,4.244,0,0,1-3.874-1.85h-.055V53.1H89.485V39.059q0-2.088-.11-4.289h2.664l.169,2.067h.059a5.538,5.538,0,0,1,8.626-.51,6.977,6.977,0,0,1,1.616,4.8",
    transform: "translate(-10.526 -5.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M117.2,41.232a5.185,5.185,0,0,0-.9-3.137,3.152,3.152,0,0,0-2.636-1.287,3.334,3.334,0,0,0-3.222,2.577,3.468,3.468,0,0,0-.141.879v2.172a3.388,3.388,0,0,0,.906,2.4,3.089,3.089,0,0,0,2.374.978,3.141,3.141,0,0,0,2.664-1.261,5.368,5.368,0,0,0,.955-3.321m3.084-.109a7.2,7.2,0,0,1-1.878,5.253,5.616,5.616,0,0,1-4.18,1.715,4.251,4.251,0,0,1-3.874-1.85H110.3V53.1h-3.033V39.059q0-2.088-.11-4.289h2.664l.169,2.067h.059a5.1,5.1,0,0,1,4.6-2.334,5.167,5.167,0,0,1,4.029,1.823,6.974,6.974,0,0,1,1.609,4.8",
    transform: "translate(-12.621 -5.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M140.351,41.791a4.72,4.72,0,0,1-1.682,3.752,7.679,7.679,0,0,1-5.149,1.58A9.38,9.38,0,0,1,128.613,46l.7-2.409a8.629,8.629,0,0,0,4.384,1.149A4.284,4.284,0,0,0,136.367,44a2.377,2.377,0,0,0,.951-1.975,2.464,2.464,0,0,0-.782-1.853,7.461,7.461,0,0,0-2.612-1.4q-4.968-1.772-4.966-5.181a4.5,4.5,0,0,1,1.74-3.65,7.085,7.085,0,0,1,4.628-1.425,9.572,9.572,0,0,1,4.294.859l-.758,2.36a7.737,7.737,0,0,0-3.618-.833,3.767,3.767,0,0,0-2.5.75,2.114,2.114,0,0,0-.758,1.636,2.161,2.161,0,0,0,.868,1.768,10.031,10.031,0,0,0,2.75,1.4,9.377,9.377,0,0,1,3.591,2.2,4.486,4.486,0,0,1,1.151,3.137",
    transform: "translate(-15.148 -4.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M152.161,36.387h-3.339V42.71q0,2.414,1.771,2.413a5.689,5.689,0,0,0,1.344-.132l.083,2.2a7.022,7.022,0,0,1-2.354.323,3.739,3.739,0,0,1-2.809-1.043,4.978,4.978,0,0,1-1.01-3.512V36.387h-1.992V34.215h1.992V31.832l2.974-.859v3.242h3.339",
    transform: "translate(-16.943 -4.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M165.426,41.271a5.661,5.661,0,0,0-.817-3.091,3.008,3.008,0,0,0-2.719-1.56,3.062,3.062,0,0,0-2.778,1.56,5.77,5.77,0,0,0-.81,3.147,5.639,5.639,0,0,0,.81,3.087,3.084,3.084,0,0,0,2.754,1.56,3.047,3.047,0,0,0,2.719-1.586,5.649,5.649,0,0,0,.841-3.117m3.143-.092a6.942,6.942,0,0,1-1.8,4.931,6.557,6.557,0,0,1-4.994,1.981,6.246,6.246,0,0,1-4.787-1.9,6.746,6.746,0,0,1-1.778-4.8,6.878,6.878,0,0,1,1.837-4.957A6.5,6.5,0,0,1,162,34.5a6.38,6.38,0,0,1,4.828,1.9,6.686,6.686,0,0,1,1.74,4.773",
    transform: "translate(-18.281 -5.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M180.542,37.318a5.506,5.506,0,0,0-.955-.079,2.918,2.918,0,0,0-2.471,1.152,4.208,4.208,0,0,0-.755,2.571V47.8h-3.029l.024-8.923q0-2.256-.11-4.1h2.64l.11,2.495h.079a4.483,4.483,0,0,1,1.516-2.064,3.8,3.8,0,0,1,2.192-.7,5.245,5.245,0,0,1,.758.053",
    transform: "translate(-20.404 -5.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M192.366,39.913a3.8,3.8,0,0,0-.586-2.225,2.69,2.69,0,0,0-2.416-1.208,2.927,2.927,0,0,0-2.412,1.182,4.162,4.162,0,0,0-.893,2.251Zm2.888.75a6.754,6.754,0,0,1-.107,1.313h-9.088a3.686,3.686,0,0,0,1.316,2.949,4.631,4.631,0,0,0,2.974.908,10.483,10.483,0,0,0,3.677-.616l.476,2.011a11.942,11.942,0,0,1-4.577.806,6.779,6.779,0,0,1-4.98-1.787,6.416,6.416,0,0,1-1.809-4.783,7.23,7.23,0,0,1,1.685-4.9,5.909,5.909,0,0,1,4.766-2.09,5.163,5.163,0,0,1,4.466,2.09,6.8,6.8,0,0,1,1.2,4.1",
    transform: "translate(-21.569 -5.425)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/appleStore.53e4de9f98609a497e1aa9c82e9bb962.svg";
export { ForwardRef as ReactComponent };